import { render, staticRenderFns } from "./autoAssembly.vue?vue&type=template&id=526c1772&scoped=true"
import script from "./autoAssembly.vue?vue&type=script&lang=js"
export * from "./autoAssembly.vue?vue&type=script&lang=js"
import style0 from "./autoAssembly.vue?vue&type=style&index=0&id=526c1772&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "526c1772",
  null
  
)

export default component.exports